import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { ClaimRow } from '../../../../models/api/view/claim-view/claim-row';
import { Payment } from '../../../../models/api/view/claim/financials/payment-history/payment';
import { BaseComponent } from '../../../base/base.component';
import { ProgressbarComponent } from '../../../core/labels/progressbar.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { EmptyStateComponent } from '../../../core/panels/empty-state.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { HandleLoadingState } from '../../../../decorators/handle-loading-state.decorator';

@Component({
  selector: 'app-payment-detail-tab',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    TableComponent,
    ColumnComponent,
    EmptyStateComponent,
    ProgressbarComponent,
  ],
  template: `
    @if (loading) {
      <app-empty-state
        height="300px"
        icon="fa-light fa-file-arrow-down"
        label="Loading payments"
        message="Retrieving from payments repository"
      >
        <div class="tw-py-4">
          <app-progressbar />
        </div>
      </app-empty-state>
    } @else if (error) {
      <app-empty-state
        height="300px"
        icon="fa-light fa-triangle-exclamation"
        label="An error has occurred"
      />
    } @else if (payment) {
      <div class="tw-flex tw-gap-8">
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="payment">
            <app-detail-item label="Document type" name="docType" />
            <app-detail-item label="Bank account" name="bankNum" />
            <app-detail-item
              label="Check cleared"
              name="chkCleared"
              format="b"
            />
            <app-detail-item label="Payment method" name="payVia" />
            <app-detail-item
              labelCase="none"
              label="Tax ID"
              name="taxId"
              format="pl"
            >
            </app-detail-item>
            <app-detail-item label="Payee" name="payee" />
          </app-detail-panel>
          <app-detail-panel [dataSource]="payment">
            <app-detail-item label="Mailing address" name="address" />
          </app-detail-panel>
        </div>
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="payment">
            <app-detail-item label="Payment type" name="paymentType">
              <ng-template #value let-detail>
                {{ paymentStatus }}
              </ng-template>
            </app-detail-item>
            <app-detail-item
              labelCase="none"
              label="Check/ACH #"
              name="checkNum"
            />
            <app-detail-item
              label="Check cleared date"
              name="dateClear"
              format="d"
            />
            <app-detail-item label="Date voided" name="dateVoid" format="d" />
            <app-detail-item label="1099 exempt" name="ind1099" format="b" />
            <app-detail-item
              label="Schedule date"
              name="dateScheduled"
              format="d"
            />
          </app-detail-panel>
        </div>
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="payment">
            <app-detail-item
              labelCase="none"
              label="Check/ACH total"
              name="paidTotal"
              format="c"
            />
            <app-detail-item label="comments" name="payComments" />
            <app-detail-item label="Payee type" name="nameType" />
            <app-detail-item label="Unallocated" name="unalloc" />
            <app-detail-item name="dateMailed" label="Mail date" format="d" />
          </app-detail-panel>
        </div>
      </div>
      @if (workersComp && payment?.attributes?.length > 0) {
        <div class="tw-basis-full">
          <app-table
            [dataSource]="payment.attributes"
            [pageSize]="5"
            [scrollable]="false"
            dataKey="id"
            recordLabel="Attribute"
            [theme]="'Dark'"
          >
            <app-column name="attributeType" label="type" />
            <app-column name="attributeValue" label="value" />
            <app-column name="attributeCategory" label="category" />
            <app-column name="attributeSubCategory" label="Sub category" />
            <app-column name="deleted" label="Deleted" format="b" />
          </app-table>
        </div>
      }
    }
  `,
  styles: [],
})
export class PaymentDetailTabComponent extends BaseComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  @Input() paymentuid!: number;
  @Input() allocateUid!: string;
  @Input() recordSource!: string;
  @Input() recordId!: string;
  @Input() workersComp = false;
  @Input() paymentStatus = '';

  claim: ClaimRow;
  payment: Payment | null = null;
  loading = false;
  error: any = null;

  @HandleLoadingState()
  async ngOnInit() {
    this.claim = this.view.currentClaim();
    this.payment = await this.api.paymentHistory.getPayment(
      this.recordSource,
      this.recordId,
      this.allocateUid,
    );
    this.cdr.detectChanges();
  }
}
